import { APPOINTMENT_STATUSES, SERVICE_ACTIVATION_PRODUCTS_TYPES } from 'features/order-tracker/utils/entries';

export const APPOINTMENTS_STATUSES = [
  APPOINTMENT_STATUSES.Booked,
  APPOINTMENT_STATUSES.Confirmed,
  APPOINTMENT_STATUSES.AtRisk,
  APPOINTMENT_STATUSES.Rejected,
  APPOINTMENT_STATUSES.SupplierChanged,
  APPOINTMENT_STATUSES.CustomerMissed,
  APPOINTMENT_STATUSES.ReAppointEUMissed,
  APPOINTMENT_STATUSES.ReAppointORMissed,
  APPOINTMENT_STATUSES.SupplierMissed,
  APPOINTMENT_STATUSES.SupplierDelayed,
  APPOINTMENT_STATUSES.Completed,
  APPOINTMENT_STATUSES.Closed,
];

export const APPOINTMENT_COMPLETED_STATUSES = [APPOINTMENT_STATUSES.Completed, APPOINTMENT_STATUSES.Closed];

export const APPOINTMENT_AMENDABLE_STATUSES = [
  APPOINTMENT_STATUSES.Confirmed,
  APPOINTMENT_STATUSES.AtRisk,
  APPOINTMENT_STATUSES.Rejected,
  APPOINTMENT_STATUSES.SupplierChanged,
];
export const APPOINTMENT_WITH_SITE_CONTACT_STATUSES = [
  ...APPOINTMENT_AMENDABLE_STATUSES,
  APPOINTMENT_STATUSES.Booked,
  APPOINTMENT_STATUSES.CustomerMissed,
  APPOINTMENT_STATUSES.ReAppointEUMissed,
];

export const PRODUCT_TYPES = {
  expert: 10,
  broadband: 3,
};

export const APPOINTMENT_TEXT = {
  broadband: 'Engineer visit for BT Business order',
  engineer: 'Engineering appointment for',
  expert: 'Expert Setup for BT Business order',
};

export const CARRIER_SHORT_NAME_MAP = {
  DPD: 'DPD',
  'Royal Mail Tracked': 'Royal Mail',
  'Parcelforce All day week': 'Parcelforce',
};

export const ITEM_AWAITING_DISPATCH = 'item awaiting dispatch';
export const ITEMS_AWAITING_DISPATCH = 'items awaiting dispatch';
export const TRACKING_DELIVERY_DETAILS_FAILED = 'Delivery details failed';
export const DELIVERY_DETAILS_FAILED_TITLE = 'Sorry, something’s gone wrong';
export const DELIVERY_DETAILS_FAILED_SUBTITLE =
  'As soon as we’ve fixed the problem, we’ll show your delivery details here.';
export const SECONDARY_CLASS_ID = 'Secondary class';
export const TO_BE_CONFIRMED_ID = 'Deliveries to be confirmed';
export const TO_BE_CONFIRMED_REFERENCE = 'To be confirmed';
export const COURIER_TO_BE_CONFIRMED = 'Courier to be confirmed';
export const DELIVERY_TO_BE_SENT = 'Delivery date to be confirmed';

export const ESTIMATED_DELIVERY_MESSAGE =
  "We estimate your delivery date when your order's placed. This is an estimate only and it can change.";

export const SERVICE_ACTIVATION_TITLE = {
  [SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAndCVE]: 'Service activation',
  [SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAppointmentAndCVE]: 'Service activation',
  [SERVICE_ACTIVATION_PRODUCTS_TYPES.BBProduct]: 'Broadband service activation',
  [SERVICE_ACTIVATION_PRODUCTS_TYPES.BBAppointment]: 'Broadband service activation',
  [SERVICE_ACTIVATION_PRODUCTS_TYPES.CVEProduct]: 'Cloud Voice Express activation',
  [SERVICE_ACTIVATION_PRODUCTS_TYPES.nonHalo]: 'Order activation',
};

export const MS_IN_DAY = 24 * 60 * 60 * 1000;
export const OPENREACH_ENGINEER_APPOINTMENT_TITLE = 'Engineer visit';

export const KCI2_ASSURE_APPT_TYPE = 'KCI2 Assure';

export const MILESTONES_NAMES_MAPPER={
  "Openreach engineer appointment":"Engineer visit",
  "Expert set up appointment":"Expert Setup",
};
export const TITLE_NAMES_MAPPER={
  "Expert set up appointment":"Expert Setup",
  "Openreach engineer appointment":"Engineer visit",
};